import { StarOutlined } from "@ant-design/icons";
import {
  Avatar,
  Badge,
  Card,
  Col,
  Popover,
  Row,
  Space,
  Tag,
  theme,
  Typography,
} from "antd";
import {
  CarIcon,
  MobileIcon,
  ProviderIcon,
  UserIcon,
} from "../../../../shared/constants/Images";
import ProviderDTO from "../../../../shared/dtos/providerDTO";
import { useMemo } from "react";
import { CardItem } from "../../../../shared/components/CardImageText";
import {
  AntDesignWhite,
  IconDarkMode,
} from "../../../../shared/constants/Resources";
import ProviderServiceDTO from "../../../../shared/dtos/providerServiceDTO";

const { Text } = Typography;

interface ProviderCardProps {
  provider: ProviderDTO;
  selectedProviderId?: number | null;
  service?: ProviderServiceDTO | null;
}

export const ProviderCard = ({
  provider,
  selectedProviderId,
  service,
}: ProviderCardProps) => {
  const {
    token: { colorText },
  } = theme.useToken();
  const isTextDarkMode = colorText === AntDesignWhite;
  const numServices = useMemo(() => {
    return provider?.services?.length || 0;
  }, [provider?.services?.length]);

  return (
    <Card
      hoverable
      styles={{
        body: {
          padding: "5px 10px",
          background:
            selectedProviderId === provider.id
              ? !isTextDarkMode
                ? "#e5e5e5"
                : "rgb(99 99 99)"
              : "",
        },
      }}
    >
      <Row gutter={[0, 4]} className="custom-cart-provider-to-assign">
        <Col span={18}>
          <Space>
            <CardItem
              isTextDarkMode={isTextDarkMode}
              src={UserIcon}
              text={`${provider?.firstName} ${provider.lastName}`}
            />
          </Space>
        </Col>
        <Col span={6} className="align-data-to-right">
          <Space>
            <StarOutlined style={{ fontSize: "20px" }} />
            <Text>{provider?.rating}</Text>
          </Space>
        </Col>
        <Col span={12}>
          <Space>
            <CardItem
              isTextDarkMode={isTextDarkMode}
              src={MobileIcon}
              text={provider?.mobile!}
            />
          </Space>
        </Col>
        <Col span={12} className="align-data-to-right">
          <Popover
            placement="right"
            title={
              numServices > 1 ? "Servicios brindados por el conductor:" : ""
            }
            content={
              numServices > 1 ? (
                <Row style={{ display: "flex", gap: 5, width: 250 }}>
                  {provider?.services?.map((s, index) => (
                    <Tag key={index}>{s.serviceType?.name}</Tag>
                  ))}
                </Row>
              ) : undefined
            }
          >
            <Space>
              <Badge
                count={numServices > 1 ? provider?.services?.length : null}
                size="small"
              >
                <Avatar
                  src={ProviderIcon}
                  size="small"
                  style={{
                    filter: isTextDarkMode ? IconDarkMode : "",
                  }}
                />
              </Badge>
              <Text>{service?.serviceType?.name || ""}</Text>
            </Space>
          </Popover>
        </Col>
        <Col span={24}>
          <Space>
            <CardItem
              isTextDarkMode={isTextDarkMode}
              src={CarIcon}
              text={service?.serviceModel || "Autos"}
            />
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default ProviderCard;
